import makeStyles from '@mui/styles/makeStyles';

export const useWorkflowStyles = makeStyles(theme => ({
  backBtn: {
    fontSize: 25,
    marginRight: 4,
    cursor: 'pointer',
  },
  title: {
    fontSize: 22,
    marginLeft: 4,
    fontWeight: 'bolder',
  },
  nodeContainer: {
    padding: '16px',
    margin: '10px 0',
    border: '2px solid #90cbf9',
    borderRadius: '8px',
    cursor: 'pointer',
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(33, 150, 243, 0.1)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: '#2196f3',
      boxShadow: '0 4px 12px rgba(33, 150, 243, 0.2)',
      transform: 'translateY(-2px)',
    },
  },
  nodeConnector: {
    margin: '-10px 0',
    textAlign: 'center',
    fontSize: '20px',
    color: '#90cbf9',
  },
  nodeTitle: {
    background: '#E3F2FD',
    fontWeight: 'bolder',
  },
  drawerContent: {
    width: '30vw',
    padding: theme.spacing(3),
    maxHeight: '100vh',
    overflowY: 'auto',
  },
  conditionChipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  addConditionButton: {
    marginTop: theme.spacing(1),
  },
  ruleContainer: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
  chosenConditionColor: {
    color: '#2196F3',
    fontWeight: 'bolder',
  },
  taskRowSeparator: {
    borderBottom: '1px solid #CCC',
  },
  taskRow: {
    color: '#2196F3',
  },
  paperContainer: {
    padding: '16px',
    zIndex: 1050,
    marginTop: '-20px',
    position: 'relative',
  },
}));
